<template>
  <mt-popup v-model="popupVisible" position="bottom" class="popup-address">
    <div class="hd">
      <div class="aside" @click="onConfirm">完成</div>
    </div>
    <mt-picker :slots="addressSlots" valueKey="name" @change="onAddressChange"></mt-picker>
  </mt-popup>
</template>
<script>
// 接口
import { getAddress } from '@/api/base'

export default {
  name: 'CityPicker',
  props: {},
  data() {
    return {
      addressList: [],
      addressSlots: [
        { flex: 1, defaultIndex: 0, values: [] },
        { flex: 1, defaultIndex: 0, values: [] },
        { flex: 1, defaultIndex: 0, values: [] }
      ],
      addressValues: [],
      popupVisible: false
    }
  },
  methods: {
    open() {
      this.popupVisible = true
    },
    // 获取省市区
    getAddress() {
      getAddress().then(response => {
        this.addressList = [...this.addressList, ...response]
        let results = this.getAddressSlots()
        this.addressSlots[0].values = results.province
      })
    },
    onAddressChange(picker, values) {
      let [province = {}, city = {}, area = {}] = values
      let provinceId = province.id || null
      let cityId = city.id || null
      let areaId = area.id || null
      // 市
      picker.setSlotValues(
        1,
        this.getAddressSlots(provinceId, cityId, areaId).city
      )
      // 区
      picker.setSlotValues(
        2,
        this.getAddressSlots(provinceId, cityId, areaId).area
      )
      this.addressValues = values
    },
    getAddressSlots(provinceId, cityId, areaId) {
      let results = { province: [], city: [], area: [] }
      this.addressList.forEach(province => {
        // 省
        provinceId = provinceId || this.addressList[0].provinceId
        results.province.push({
          id: province.provinceId,
          name: province.provinceName
        })
        // 市
        if (provinceId === province.provinceId) {
          province.city.forEach(city => {
            cityId = cityId || province.city[0].cityId
            results.city.push({ id: city.cityId, name: city.cityName })

            // 区
            if (cityId === city.cityId) {
              city.area.forEach(area => {
                results.area.push({ id: area.areaId, name: area.areaName })
              })
            }
          })
        }
      })
      return results
    },
    onConfirm() {
      this.popupVisible = false
      this.$emit('confirm', this.addressValues)
    }
  },
  created() {
    this.getAddress()
  }
}
</script>
<style>
.popup-address {
  width: 100%;
}
.popup-address .hd {
  height: 46px;
  padding: 0 20px;
  background: #f8f8f8;
  box-shadow: 0px 0.5px 0px 0px #dadada;
}
.popup-address .hd .aside {
  float: right;
  font-size: 16px;
  line-height: 46px;
  text-align: right;
  color: #007aff;
}
</style>
